import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
})
export class AppComponent {
  title = 'ecl-inspire-frontend';

  constructor(
    private auth: AuthService,
    private router: Router
  ) { }

  async ngOnInit() {
    try {
      await this.auth.getCurrentSession();
      this.router.navigate(['/dashboard']);
    } catch (_) {
      this.router.navigate(['/login']);
    }
  }
}
